import requestAction from '../../utils/requestAction'

export const fetchComplaintMessage = (complaintMessageId: string) =>
  requestAction('COMPLAINT_MESSAGE_DETAIL')(`complaints/message/${complaintMessageId}`, 'GET')
